// extracted by mini-css-extract-plugin
module.exports = {"scrollbarHide":"landing-page-collection-slider_scrollbarHide__iT_vh"};